// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  display: flex;
  border: transparent;
  padding: 10px 24px;
  gap: 8px;
  left: calc(50% - 172px);
  bottom: 25.35px;
  border-radius: 8px;
}

button.btn-outline-dark-blue:disabled {
  cursor: not-allowed !important;
  color: var(--color-disabled-btn) !important;
  border-color: var(--color-disabled-btn) !important;
}`, "",{"version":3,"sources":["webpack://./src/infraestructure/styles/button.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AACJ;;AAIQ;EACI,8BAAA;EACA,2CAAA;EACA,kDAAA;AADZ","sourcesContent":["button {\n    display: flex;\n    border: transparent;\n    padding: 10px 24px;\n    gap: 8px;\n    left: calc(50% - 172px);\n    bottom: 25.35px;\n    border-radius: 8px\n}\n\nbutton {\n   &.btn-outline-dark-blue {\n        &:disabled {\n            cursor: not-allowed !important;\n            color: var(--color-disabled-btn) !important;\n            border-color: var(--color-disabled-btn) !important;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
